import React from 'react';
import './style.scoped.scss';
import { useHistory } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';
import { Content } from '../Content';
import { Policies } from '../Policies';

// Doc page title -> playground endpoint type, for the "Try it" deep link.
const PLAYGROUND_TYPE_BY_TITLE = {
  'GET Documents': 'getDocuments',
  'GET Document by ID': 'getDocByID',
  'GET Sections of a Document by ID': 'getSectionsByID',
  'GET Related Documents by ID': 'getRelatedDocumentsByDocID',
  'GET Glossary of a Document by ID': 'getGlossaryByDocId',
  'GET Summary by ID': 'getSummaryByDocID',
  'GET Section by ID': 'getSectionByPageID',
  'GET Related Sections by ID': 'getRelatedSectionsByPageID',
};

const Documentation = ({ selectedItem, handlecopy, isDocumentation }) => {
  const history = useHistory();

  const playgroundType =
    isDocumentation && PLAYGROUND_TYPE_BY_TITLE[selectedItem.title];

  return (
    <div className='docContent'>
      <div className='docContent__inner'>
        <div className='docContent__header'>
          <h3 className='docContent__header__title'>{selectedItem.title}</h3>
          {playgroundType && (
            <button
              className='wf-button docContent__header__try'
              type='button'
              onClick={() =>
                history.push(`/api/explorer?endpoint=${playgroundType}`)
              }
            >
              <FaPlay size={11} />
              Try it in the API Explorer
            </button>
          )}
        </div>
        {isDocumentation
          ? Content(handlecopy).map((item, index) => {
              if (item.title === selectedItem.title)
                return (
                  <React.Fragment key={index}>{item.content}</React.Fragment>
                );
              else return null;
            })
          : Policies.map((item, index) => {
              if (item.title === selectedItem.title)
                return (
                  <React.Fragment key={index}>{item.content}</React.Fragment>
                );
              else return null;
            })}
      </div>
    </div>
  );
};

export default Documentation;
